const theme = {
  colorPrimary: '#5a5e62',
  colorSecondary: '#F45454',
  colorError: '#F45454'
}

export default theme;